import React, { useEffect, useRef, useState } from "react";
import { FaUser } from "react-icons/fa";
import { FaPowerOff } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import apiRequests from "../axios/config/config";
import { FaAlignJustify } from "react-icons/fa6";
import SideBar from "../sidebar/sidebar";
import { motion, AnimatePresence } from "framer-motion";

export default function Header() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  function logout() {
    localStorage.clear();
    window.location.reload();
  }

  useEffect(() => {
    if (!userName) {
      apiRequests
        .get("/api/admin/v1/get-my-profile")
        .then((res) => {
          setUserName(
            res.data.data.firstName + " " + res.data.data.lastName,
          );
        })
        .catch(() => {
          setUserName("-");
        });
    }
  }, [userName]);

  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const day = date.toLocaleDateString("en-US", {
    weekday: "long",
  });

  const formattedDate = date.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const time = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return (
    <>
      <div className="flex items-center px-10 md:px-2">
        <div className="flex items-center justify-between bg-firstColor-shade4 text-white rounded-xl py-3 px-5 my-2 w-full sm:flex-col sm:gap-4 sm:items-start">
          <div className="flex gap-3">
            <button
              className="text-[18px] hidden md:block"
              onClick={() => setShowMenu(!showMenu)}
            >
              <FaAlignJustify />
            </button>

            <div className="flex gap-1 items-center">
              <FaUser />
              Welcome dear {userName}
            </div>
          </div>

          <div className="flex gap-2 items-center sm:justify-between sm:w-full">
            <div className="flex gap-2 items-center">
              <p>{day}</p>
              <span>|</span>
              <p>{formattedDate}</p>
              <span>|</span>
              <p>{time}</p>
            </div>

            <div
              className="text-red-600 hover:cursor-pointer"
              onClick={logout}
            >
              <FaPowerOff />
            </div>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {showMenu && <MenuTitle setHow={setShowMenu} />}
      </AnimatePresence>
    </>
  );
}

export function MenuTitle({ setHow }) {
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setHow(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="hidden md:fixed md:z-10 md:flex md:top-0 md:bg-black md:bg-opacity-50 md:h-full md:w-full">
      <motion.div
        initial={{ x: "-100%" }}
        animate={{ x: 0 }}
        exit={{ x: "-100%" }}
        transition={{ duration: 0.3 }}
        className="md:text-black md:flex md:flex-col md:w-[70%] md:h-full md:bg-black md:rounded-r-[20px] md:gap-6"
        ref={dropdownRef}
      >
        <SideBar setShowMenuMobile={setHow} />
      </motion.div>

      <div className="w-[30%]" onClick={() => setHow(false)}></div>
    </div>
  );
}